import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import UserBoardService from '../../service/UserBoardService';
import Button from '../atom/Button';
import TextInput from '../atom/TextInput';

const ModalArea = styled.section`
  width: 100%;
  max-width: 590px;
  margin: 0 auto;
  border-radius: 0.3rem;
  background-color: #fff;
  animation: modal-show 0.3s;
  overflow: hidden;
  height: 350px;
  padding: 50px;
  box-sizing: border-box;
  @media ${props => props.theme.device.mobile} {
    height: 350px;
  }
`;
interface modalLookupProps {
  close: () => void;
  open: boolean;
  text: string;
}
const ModalLookup = (props: modalLookupProps) => {
  const navigate = useNavigate();
  const { open, close } = props;
  const [formData, setFormData] = useState({
    vocNumber: '',
    phoneNumber: '',
    password: ''
  });
  // const [windowWitdh, setWindowWitdh] = useState(window.innerWidth);

  const changeVocNum = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      vocNumber: e.target.value
    });
  };
  const changePhoneNum = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      phoneNumber: e.target.value
    });
  };
  const changePwd = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      password: e.target.value
    });
  };

  const submitFormData = async () => {
    const regExp2 = /^(015|010)\d{3,4}\d{4}$/;
    // console.log(regExp2, regExp2.test(formData.phoneNumber));
    const result: boolean = regExp2.test(formData.phoneNumber);
    // console.log(result);
    const response: any = await UserBoardService.searchVoc(formData);
    console.log(response);

    if (result == true && !!response.data.content) {
      console.log('성공');
      navigate('/UserVocDetail', { state: response.data });
    } else if (regExp2.test(formData.phoneNumber) == false) {
      alert('휴대폰 번호를 다시한번 확인해 주세요');
      // navigate(-1);
    } else if (response.data == '휴대폰 번호가 틀렸습니다.') {
      alert('휴대폰 번호가 틀렸습니다.');
    } else if (response.data == '패스워드가 틀렸습니다.') {
      alert('패스워드가 틀렸습니다.');
    }
    // if (!!response.data.content) {
    //   navigate("/UserVocDetail", { state: response.data });
    // } else {
    //   return alert("일치되는 문의글이 없습니다 다시한번 확인해주세요");
    //   navigate(-1);
    // }
  };

  const handleInputLength = (e: any) => {
    const target = e.target;

    if (target.value.length > target.maxLength) {
      target.value = target.value.slice(0, target.maxLength);
    }
  };

  return (
    <div className={open ? 'openModal modal' : 'modal'}>
      {open ? (
        <ModalArea>
          <main className="LookUp_Modal">{props.text}</main>
          <TextInput
            labelName={'게시글 번호'}
            type={'number'}
            onChange={changeVocNum}
            maxLength={4}
            onInput={handleInputLength}
            placeholder=" 게시글 번호"
            inputWidth={70}
            margin={'10px'}
          />

          <TextInput
            labelName={'휴대폰 번호'}
            placeholder=" '-' 을 제외한 숫자"
            type={'number'}
            onChange={changePhoneNum}
            maxLength={11}
            onInput={handleInputLength}
            inputWidth={70}
            margin={'10px'}
          />

          <TextInput
            labelName={'패스워드'}
            type={'password'}
            onChange={changePwd}
            maxLength={6}
            placeholder=" 6자리 이내"
            inputWidth={70}
            margin={'20px'}
          />

          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              width: '100%',
              marginTop: '14px'
            }}
          >
            <Button
              onClick={submitFormData}
              text={'확인'}
              backgroundColor={'#388fc0'}
              fontColor={'white'}
              borderRadius={'5px'}
              width={'100px'}
            />

            <Button
              onClick={close}
              text={'취소'}
              backgroundColor={'#fff'}
              fontColor={'#388fc0'}
              borderRadius={'5px'}
              width={'100px'}
              marginLeft={'10px'}
            />
          </div>
        </ModalArea>
      ) : null}
    </div>
  );
};

export default ModalLookup;
